import { styled, Switch } from '@mui/material'

export const BlueSwitch = styled(Switch)(({ theme }) => ({
  width: '42px',
  height: '26px',
  padding: 0,
  '& .MuiSwitch-switchBase': {
    padding: 0,
    margin: 2,
    transitionDuration: '300ms',
    '&.Mui-checked': {
      transform: 'translateX(16px)',
      color: theme.palette.commonColors.white,
      '& + .MuiSwitch-track': {
        backgroundColor: theme.palette.primary.main,
        opacity: 1,
      },
      '&.Mui-disabled + .MuiSwitch-track': {
        backgroundColor: theme.palette.commonColors.white,
        border: `1px solid ${theme.palette.action.disabled}`,
      },
    },
    '&.Mui-disabled .MuiSwitch-thumb': {
      color: theme.palette.grey[100],
    },
    '&.Mui-disabled + .MuiSwitch-track': {
      opacity: 0.7,
    },
  },
  '& .MuiSwitch-thumb': {
    boxSizing: 'border-box',
    width: 22,
    height: 22,
  },
  '& .MuiSwitch-track': {
    border: `1px solid ${theme.palette.icon.main}`,
    borderRadius: 26 / 2,
    backgroundColor: theme.palette.commonColors.white,
    opacity: 1,
    transition: theme.transitions.create(['background-color'], {
      duration: 500,
    }),
  },
}))
